/*
  NUMU Media 2026: product sliders on the product page
  (related products, "Har du brug for mere plads?" add-ons, packages).

  One list = one Slick instance. Guards against double init, re-inits after
  theme editor section reloads, and keeps the arrows centred on the product
  image (not on the whole card) on every breakpoint.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-numu-slider]';

  function positionArrows(root) {
    var slider = root.querySelector('.slick-slider');
    var media = root.querySelector('.slick-active .card__inner') || root.querySelector('.slick-slide .card__inner');
    if (!slider || !media) return;
    var top = media.getBoundingClientRect().top - slider.getBoundingClientRect().top + media.offsetHeight / 2;
    if (top > 0) root.style.setProperty('--numu-arrow-top', Math.round(top) + 'px');
  }

  function init(root) {
    if (!root || !window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;
    var $ = window.jQuery;
    var $list = $(root).find('.numu-pslider__list').first();
    if (!$list.length || $list.hasClass('slick-initialized')) return;

    $list.on('init setPosition', function () {
      positionArrows(root);
    });

    $list.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      speed: 300,
      swipeToSlide: true,
      touchThreshold: 8,
      responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }]
    });

    root.classList.add('numu-pslider--ready');

    // Images inside cards may finish loading after init: recentre arrows once they do.
    Array.prototype.forEach.call(root.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', function () { positionArrows(root); }, { once: true });
    });
  }

  function destroy(root) {
    if (!root || !window.jQuery) return;
    var $list = window.jQuery(root).find('.numu-pslider__list.slick-initialized');
    if ($list.length) $list.slick('unslick');
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(SELECTOR), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll(SELECTOR), destroy);
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (root) positionArrows(root);
  });
})();
